import * as e from "react";
const r = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 490 425",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      opacity: 0.2,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M64.427 175.993a100 100 0 0139.904-89.885l63.206-46.954a99.998 99.998 0 0190.206-14.938l118.68 38.108c46.508 14.934 75.421 61.283 68.384 109.62l-15.823 108.671a100 100 0 01-54.955 75.392l-82.057 40.207a99.995 99.995 0 01-69.069 7.007l-72.294-18.72c-40.677-10.534-70.43-45.373-74.469-87.197L64.427 175.993z",
      fill: "url(#error-state-report-builder_svg__paint0_linear_3603_315811)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "ellipse",
    {
      opacity: 0.1,
      cx: 253.5,
      cy: 340.5,
      rx: 147.5,
      ry: 9,
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M339.25 38.25a1.25 1.25 0 010 2.5h-5v5a1.25 1.25 0 01-2.5 0v-5h-5a1.25 1.25 0 110-2.5h5v-5a1.25 1.25 0 112.5 0v5h5z",
      fill: "#F3C231",
      opacity: 0.7
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M252.25 367.143a1.25 1.25 0 110 2.5h-5v5a1.25 1.25 0 01-2.5 0v-5h-5a1.25 1.25 0 110-2.5h5v-5a1.25 1.25 0 112.5 0v5h5z",
      fill: "#F3C231",
      opacity: 0.8
    }
  ),
  /* @__PURE__ */ e.createElement(
    "rect",
    {
      x: 170,
      y: 148.5,
      width: 167.149,
      height: 167.149,
      rx: 27.723,
      stroke: "#2d6ded",
      strokeWidth: 2
    }
  ),
  /* @__PURE__ */ e.createElement(
    "rect",
    {
      x: 181.703,
      y: 160.202,
      width: 144.277,
      height: 144.277,
      rx: 12.83,
      fill: "#fff",
      stroke: "#2d6ded",
      strokeWidth: 2
    }
  ),
  /* @__PURE__ */ e.createElement("mask", { id: "error-state-report-builder_svg__a", fill: "#fff" }, /* @__PURE__ */ e.createElement(
    "rect",
    {
      x: 180.703,
      y: 236.33,
      width: 141.927,
      height: 9.574,
      rx: 1.064
    }
  )),
  /* @__PURE__ */ e.createElement(
    "rect",
    {
      x: 180.703,
      y: 236.33,
      width: 141.927,
      height: 9.574,
      rx: 1.064,
      fill: "#B3B9DD",
      stroke: "#2d6ded",
      strokeWidth: 4,
      mask: "url(#error-state-report-builder_svg__a)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      opacity: 0.2,
      d: "M203.774 292.746L188 303l9 2h115l8-3 7-7.5V286l-2.5-119-3.5-4-12.268 8.716A16.002 16.002 0 00302 184.759V277c0 7.18-5.821 13-13 13h-75.961c-3.289 0-6.507.954-9.265 2.746z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M195.531 315.649c0-.035.028-.064.064-.064h25.616c.016 0 .024.003.03.006a.071.071 0 01.022.021c.008.01.011.021.012.029a.049.049 0 01-.004.029l-2.429 6.783a.064.064 0 01-.06.042h-23.187a.064.064 0 01-.064-.064v-6.782zM311.085 315.649a.064.064 0 00-.063-.064h-25.617a.054.054 0 00-.029.006.073.073 0 00-.035.05.059.059 0 00.004.029l2.429 6.783a.064.064 0 00.06.042h23.188a.064.064 0 00.063-.064v-6.782z",
      fill: "#2d6ded",
      fillOpacity: 0.2,
      stroke: "#2d6ded",
      strokeWidth: 2
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M310.957 189.968c0-12.961 10.507-23.468 23.468-23.468h9.638v129.383h-9.638c-12.961 0-23.468-10.507-23.468-23.468v-82.447z",
      fill: "#D1D5EB",
      stroke: "#2d6ded",
      strokeWidth: 2
    }
  ),
  /* @__PURE__ */ e.createElement("mask", { id: "error-state-report-builder_svg__b", fill: "#fff" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M344.063 159.5c-.587 0-1.063.476-1.063 1.064v141.872c0 .588.476 1.064 1.063 1.064h7.873c.587 0 1.064-.476 1.064-1.064v-72.957h3.563c.562 0 1.027.437 1.062.999l2.271 37.098c.034.561.5.999 1.062.999h2.191c.587 0 1.063-.477 1.063-1.064v-45.479a5.318 5.318 0 00-5.319-5.319H353v-56.149c0-.588-.477-1.064-1.064-1.064h-7.873z"
    }
  )),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M353 229.479v-2h-2v2h2zm4.625.999l1.996-.123-1.996.123zm2.271 37.098l1.996-.122-1.996.122zM353 216.713h-2v2h2v-2zm-8.937-59.213a3.063 3.063 0 00-3.063 3.064h4c0 .517-.42.936-.937.936v-4zM341 160.564v141.872h4V160.564h-4zm0 141.872a3.063 3.063 0 003.063 3.064v-4c.517 0 .937.419.937.936h-4zm3.063 3.064h7.873v-4h-7.873v4zm7.873 0a3.064 3.064 0 003.064-3.064h-4c0-.517.419-.936.936-.936v4zm3.064-3.064v-72.957h-4v72.957h4zm-2-70.957h3.563v-4H353v4zm3.563 0a.937.937 0 01-.935-.879l3.993-.245a3.064 3.064 0 00-3.058-2.876v4zm-.935-.879l2.272 37.098 3.992-.244-2.271-37.099-3.993.245zm2.272 37.098a3.064 3.064 0 003.058 2.877v-4c.495 0 .904.385.934.879l-3.992.244zm3.058 2.877h2.191v-4h-2.191v4zm2.191 0a3.063 3.063 0 003.063-3.064h-4c0-.517.42-.936.937-.936v4zm3.063-3.064v-45.479h-4v45.479h4zm0-45.479a7.319 7.319 0 00-7.319-7.319v4a3.319 3.319 0 013.319 3.319h4zm-7.319-7.319H353v4h5.893v-4zm-3.893 2v-56.149h-4v56.149h4zm0-56.149a3.064 3.064 0 00-3.064-3.064v4a.936.936 0 01-.936-.936h4zm-3.064-3.064h-7.873v4h7.873v-4z",
      fill: "#2d6ded",
      mask: "url(#error-state-report-builder_svg__b)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      opacity: 0.1,
      d: "M265 160.5l-84 37M273 161.393l-46 75M285 161.393l-10 75M293 160.5l17 34M238 161.5l5.857 8.163 14.11 16.325 22.63 2.512 23.162-5.965L320 163.384",
      stroke: "#2d6ded",
      strokeWidth: 2
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      opacity: 0.1,
      d: "M213 161.5l12.686 17.536 26.959 17.218 25.638 9.246L310 196.254",
      stroke: "#2d6ded",
      strokeWidth: 2
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      opacity: 0.1,
      d: "M184 166.5l19.885 22.401 39.77 22.401 32.612 14.198L311 216.035",
      stroke: "#2d6ded",
      strokeWidth: 2
    }
  ),
  /* @__PURE__ */ e.createElement("g", { opacity: 0.1, stroke: "#2d6ded", strokeWidth: 2 }, /* @__PURE__ */ e.createElement("path", { d: "M219 245.5l24.782 58.135M211.805 245.364l1.389 57.904M207.404 244.9l-18.529 58.368M200.224 245.132l-17.602 22.235M188.5 245l7.555 5.691 7.875 3.937 17.834-2.779" }), /* @__PURE__ */ e.createElement("path", { d: "M225.007 259.261l-12.508 1.853h-9.959l-10.654-5.791-10.423-9.728M231.723 274.779h-33.815l-10.886-12.739-6.022-6.485" })),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M424 178.393c5.522 0 10 4.477 10 10 0 5.522-4.478 10-10 10-5.523 0-10-4.478-10-10 0-5.523 4.477-10 10-10zm0 4a6 6 0 100 12 6 6 0 000-12zM232 73.5c5.522 0 10 4.477 10 10s-4.478 10-10 10c-5.523 0-10-4.477-10-10s4.477-10 10-10zm0 4a6 6 0 100 12 6 6 0 000-12z",
      fill: "#F3C231",
      opacity: 0.7
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 175.393c5.523 0 10 4.477 10 10 0 5.522-4.477 10-10 10s-10-4.478-10-10c0-5.523 4.477-10 10-10zm0 4a6 6 0 100 12 6 6 0 000-12z",
      fill: "#F3C231",
      opacity: 0.4
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M57.435 131.733c-11.888 17.463-26.497 63.906 8.48 87.268 40.642 27.143 80.116-11.909 75.16-36.8-3.965-19.913-21.808-22.884-30.312-22.269-9.697 1.392-22.095 8.847-20.248 32.336 2.362 30.057 62.641 50.605 62.641 50.605l11.344 4.02",
      stroke: "#2d6ded",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeDasharray: "10 10"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      opacity: 0.2,
      d: "M335 257.319V167h8.5v128.5H329l-7-3-7-6.5-4.5-10 .5-3 7.333.306c9.09.378 16.667-6.889 16.667-15.987z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "ellipse",
    {
      cx: 71.271,
      cy: 107.436,
      rx: 7.988,
      ry: 9.474,
      transform: "rotate(48.463 71.27 107.436)",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "circle",
    {
      cx: 81.005,
      cy: 98.814,
      r: 5.387,
      transform: "rotate(48.463 81.005 98.814)",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "ellipse",
    {
      cx: 79.686,
      cy: 111.772,
      rx: 5.573,
      ry: 10.331,
      transform: "rotate(3.554 79.686 111.772)",
      fill: "#fff",
      stroke: "#2d6ded",
      strokeWidth: 2
    }
  ),
  /* @__PURE__ */ e.createElement(
    "ellipse",
    {
      cx: 5.573,
      cy: 10.331,
      rx: 5.573,
      ry: 10.331,
      transform: "scale(1 -1) rotate(86.627 94.664 -11.02)",
      fill: "#fff",
      stroke: "#2d6ded",
      strokeWidth: 2
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M85.05 97.217c.844-.914 3.16-2.204 5.661-.052M82.955 94.852c1.009-.728 2.569-2.87.734-5.614",
      stroke: "#2d6ded",
      strokeWidth: 1.115,
      strokeLinecap: "round"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      opacity: 0.2,
      d: "M60.2 94.66c4.123 6.671 13.5 5.247 17.673 3.7l.83 1.499-3.09 3.234-6.11.946-8.205-1.418-3.326-3.754.838-2.976 1.39-1.232zM82.496 119.827c-6.125-4.897-3.58-14.033-1.543-17.989l-1.386-1.006-3.584 2.679-1.676 5.951.418 8.316 3.326 3.754 3.055-.473 1.39-1.232z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M464.641 201.133c-9.501 6.534-19.329 24.261-11.354 40.692 9.968 20.538 17.414 18.077 23.941 14.91 6.526-3.168 8.483-12.192 3.045-23.394-5.437-11.203-22.62-8.63-34.275-2.974-14.685 7.128-18.463 15.959-23.066 30.804-5.815 27.139-10.015 84.839-76.815 55.639",
      stroke: "#2d6ded",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeDasharray: "10 10"
    }
  ),
  /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
    "linearGradient",
    {
      id: "error-state-report-builder_svg__paint0_linear_3603_315811",
      x1: 258,
      y1: 432.094,
      x2: 257.46,
      y2: 25.295,
      gradientUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ e.createElement("stop", { stopColor: "#2d6ded", stopOpacity: 0.5 }),
    /* @__PURE__ */ e.createElement("stop", { offset: 1, stopColor: "#2d6ded", stopOpacity: 0.03 })
  ))
);
export {
  r as default
};
